import styled from "styled-components";

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    thead {
        background-color: #f5f5f5;
    }

    th,
    td {
        border: 1px solid #ddd;
        text-align: center;
        padding: 10px;
    }

    th {
        font-weight: bold;
        color: #333;
    }

    tr:nth-child(even) {
        background-color: #f9f9f9;
    }

    tr:hover {
        background-color: #e6f7ff;
    }
`;

export const ItemRow = styled.tr`
    color: ${(props) => (props.disabled ? "gray" : "black")};
    color: ${(props) => (props.associated ? "blue" : "")};
    pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

export const SaveButton = styled.button`
    margin-top: 20px;
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;

    &:hover {
        background-color: #0056b3;
    }

    &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }
`;

export const QuantityInput = styled.input`
    width: 50px;
    padding: 5px;
    font-size: 14px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s;

    &:focus {
        border-color: #1976d2; /* Cor primária do Material-UI */
        box-shadow: 0 0 4px rgba(25, 118, 210, 0.5); /* Efeito de foco */
    }

    &:hover {
        border-color: #999;
    }
`;
